export default __webpack_public_path__ + "static/media/Roboto-Light.a2578555.woff";